module.exports = __webpack_public_path__ + "k-fly.png?199a6ddc2f3169ab10daa6ad7892b49e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-fly.png
// module id = 14
// module chunks = 0